import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { PlanningSegmentStore } from "@app/services/store/planning-segment-store";
import { UntypedFormGroup, FormsModule } from "@angular/forms";
import { PlanningSegment } from "@app/models/rest/planning-segment";
import { MatSelectionList, MatListOption } from "@angular/material/list";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { AutoBookProfile } from "@app/models/rest/auto-book-profile";
import { firstValueFrom } from "rxjs";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgTemplateOutlet } from "@angular/common";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatIconButton, MatButton } from "@angular/material/button";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatError } from "@angular/material/form-field";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-cyclical-segment-editor",
  templateUrl: "./cyclical-segment-editor.component.html",
  styleUrls: ["./cyclical-segment-editor.component.css"],
  imports: [
    NgTemplateOutlet,
    CdkScrollable,
    MatDialogContent,
    MatSelectionList,
    FormsModule,
    MatListOption,
    MatDialogActions,
    MatButton,
    MatError,
    DialogHeaderComponent
  ]
})
export class CyclicalSegmentEditorComponent implements OnInit {
  protected segmentStore = inject(PlanningSegmentStore);
  protected serviceErrorHandler = inject(ServiceErrorHandlerService);
  dialogRef =
    inject<MatDialogRef<CyclicalSegmentEditorComponent>>(MatDialogRef);
  data = inject<{
    profile: AutoBookProfile;
  }>(MAT_DIALOG_DATA);

  @ViewChild("segmentSelection", { static: false })
  segmentSelection: MatSelectionList;
  segmentForm: UntypedFormGroup;
  public segments: PlanningSegment[] = [];
  selectedOptions: PlanningSegment[] = [];
  hasError: boolean = false;

  compareFunction = (o1: any, o2: any) => o1.id === o2.id;

  ngOnInit() {
    if (!this.data || !this.data.profile) return;
    console.log("loaded segment chooser", this.data);

    //  Check to see if ID has been assigned to row (has row been saved?)
    if (!this.data.profile.hasOwnProperty("id")) {
      this.hasError = true;
    } else {
      this.selectedOptions = this.data.profile.segments;

      this.segmentStore.loadAll().then((value) => {
        console.log("loaded segments", value);
        this.segments = value.resources;
      });
    }
  }

  save() {
    console.log("selected", this.segmentSelection.selectedOptions);

    let autobookProfile: AutoBookProfile = this.data.profile;
    firstValueFrom(autobookProfile.unbindCollectionRelation("segments"))
      .then(() => {
        firstValueFrom(
          autobookProfile.addCollectionRelation(
            "segments",
            this.selectedOptions
          )
        )
          .then(() => {
            console.log("updated relation");
            this.dialogRef.close(true);
          })
          .catch((error) => {
            this.serviceErrorHandler.handleClientError(error);
          });
      })
      .catch((error) => {
        this.serviceErrorHandler.handleClientError(error);
      });
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }
}
